import { render, staticRenderFns } from "./HiboModal.vue?vue&type=template&id=6a855ac5&scoped=true&"
import script from "./HiboModal.vue?vue&type=script&lang=ts&"
export * from "./HiboModal.vue?vue&type=script&lang=ts&"
import style0 from "./HiboModal.vue?vue&type=style&index=0&id=6a855ac5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a855ac5",
  null
  
)

export default component.exports